import { useContext } from 'react'
import Context from './context'

export function useGlobal() {
  return useContext(Context)
}